export default "__VITE_ASSET__BpmdwP3H__"